import { render, staticRenderFns } from "./ProductsSetting.vue?vue&type=template&id=68beaf1e"
import script from "./ProductsSetting.vue?vue&type=script&lang=js"
export * from "./ProductsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports